import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

export const HeaderModalSort = ({
  onSortChange,
  value,
  sortOptions,
}: {
  onSortChange: (value: string) => void;
  value: string;
  sortOptions: {
    value: string;
    label: string;
  }[];
}) => {
  return (
    <Select onValueChange={onSortChange} value={value}>
      <SelectTrigger
        className="
          h-auto w-full max-w-full min-w-0 rounded-none border-none
          bg-transparent px-0 py-2 text-left leading-none text-muted
          hover:border-transparent hover:bg-transparent
          focus:ring-0
          sm:w-auto
        "
        value={value}
      >
        <span
          className="
            hidden text-xs!
            sm:flex
          "
        >
          Sort: &nbsp;
        </span>
        <span
          className="
            min-w-0 text-xs underline-offset-4
            hover:underline
          "
        >
          <SelectValue
            placeholder="Select sort"
            className="block max-w-full truncate text-xs"
          />
        </span>
      </SelectTrigger>
      <SelectContent>
        {sortOptions.map((option) => (
          <SelectItem key={option.value} value={option.value}>
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
